import React, { useState } from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
    alignItems: 'center',
    padding: '6px 8px',
    border: '1px solid #e0e0e0',
    borderRadius: 6,
    minHeight: 38,
    backgroundColor: '#fff',
    '&:focus-within': {
      borderColor: theme.palette.primary.main,
    },
  },
  input: {
    flex: 1,
    minWidth: 120,
    border: 'none',
    outline: 'none',
    fontSize: 13,
    padding: '4px 0',
    backgroundColor: 'transparent',
    color: '#1a1a1a',
    fontFamily: "'Poppins', 'Helvetica', sans-serif",
  },
  chip: {
    fontSize: 12,
    height: 26,
    margin: '2px',
    backgroundColor: '#219A97 !important',
    color: '#fff !important',
    '&:hover': {
      backgroundColor: '#1b8c89 !important',
    },
    '&:focus': {
      backgroundColor: '#219A97 !important',
    },
    '& .MuiChip-deleteIcon': {
      color: 'rgba(255,255,255,0.7)',
      '&:hover': {
        color: '#fff',
      },
    },
  },
  chipDisabled: {
    fontSize: 12,
    height: 26,
    opacity: 0.85,
    backgroundColor: '#1b8c89 !important',
    color: '#fff !important',
    margin: '2px',
    '&:hover': {
      backgroundColor: '#1b8c89 !important',
    },
    '&:focus': {
      backgroundColor: '#1b8c89 !important',
    },
  },
  hint: {
    fontSize: '10px',
    color: '#aaa',
    marginTop: 2,
  },
}));

export function TagsInput({ value = [], onChange, placeholder = 'Digite e pressione Enter...', defaultTags = [], disabled = false }) {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState('');

  const addTag = () => {
    const tag = inputValue.trim().toLowerCase();
    if (tag && !value.includes(tag)) {
      onChange([...value, tag]);
    }
    setInputValue('');
  };

  const removeTag = (index) => {
    onChange(value.filter((_, i) => i !== index));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === 'Tab') {
      if (inputValue.trim()) {
        e.preventDefault();
        addTag();
      }
    }
    if (e.key === 'Backspace' && !inputValue && value.length > 0) {
      removeTag(value.length - 1);
    }
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        {defaultTags.map((tag, i) => (
          <Chip
            key={`default-${i}`}
            label={tag}
            size="small"
            className={classes.chipDisabled}
            disabled
          />
        ))}
        {value.map((tag, i) => (
          <Chip
            key={i}
            label={tag}
            size="small"
            className={classes.chip}
            onDelete={disabled ? undefined : () => removeTag(i)}
          />
        ))}
        {!disabled && (
          <input
            type="text"
            className={classes.input}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            onBlur={addTag}
            placeholder={value.length === 0 && defaultTags.length === 0 ? placeholder : ''}
          />
        )}
      </div>
      {!disabled && <span className={classes.hint}>Pressione Enter ou Tab para adicionar</span>}
    </div>
  );
}
